<template>
  <div class="speech-question-view">
<!--    <div class="question-desc-view">{{ questioninfo.desc }}</div>-->
    <div class="speech-question-info-view">
      <template v-if="questioninfo.content_img">
        <el-image :src="baseurl+questioninfo.content_img" class="options-img-view" lazy>
          <div slot="placeholder" class="image-slot">
            <img src="../../assets/img/question-loading.png">
          </div>
          <div slot="error" class="image-slot">
            <img src="../../assets/img/question-loading.png">
          </div>
        </el-image>
      </template>
      <template v-if="questioninfo.content">
        <div v-html="questioninfo.content"
             :class="questioninfo.content.indexOf('-')==0?'speech-word-content1':'speech-word-content'"></div>
      </template>
    </div>
    <div class="speech-btn-group">
      <div class="record-group-btn" @click="recordSpeech">
        <div class="record-btn" v-if="questioninfo.reading_time==0||isrecord"></div>
        <el-progress class="record-playing" :width="83" color="#e59b2e" :show-text="false" type="circle"
                     :percentage="parseInt(playingprogress/totaltimer*100)" v-if="isrecord">
        </el-progress>
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/api/apiUtils"
import Apis from "@/api"

export default {
  name: "speecchquestion",
  data() {
    return {
      questioninfo: {},
      baseurl: apiUtil.getBaseUrl(),
      audiourl: "",
      totaltimer: 0
    }
  },
  props: {
    questionData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isrecord: {
      type: Boolean,
      default: false
    },
    playingprogress: {
      type: Number,
      default: 0
    }
  },
  watch: {
    questionData: {
      immediate: true,  // 深度监听
      handler(newVal, oldVal) {
        this.initData()
      }
    },
    isrecord: function () {
      console.log(this.questionData.useroption)
      console.log(this.questionData.recordid)
    }
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.initData()
    })
  },
  methods: {
    initData() {
      this.questioninfo = this.questionData
      if (this.questioninfo.show_type == 1) {
        this.totaltimer = this.questioninfo.answer_time ? this.questioninfo.answer_time * 10 : 200
      } else if (this.questioninfo.show_type == 2) {
        this.totaltimer = this.questioninfo.answer_time ? this.questioninfo.answer_time * 10 : 300
      } else {
        this.totaltimer = this.questioninfo.answer_time ? this.questioninfo.answer_time * 10 : 4500
      }
    },
    recordSpeech() {
      this.$emit("recordSpeech")
    },
    playRecord() {
      if (this.questioninfo.useroption) {

      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "../../assets/css/common.styl";
.speech-question-view {
  width 100%;
  height 100%;
  display flex;
  flex-direction column;
}

.speech-question-info-view {
  display flex;
  width 100%;
  flex-direction column;
  align-items center;
  position relative
  flex 1;
  justify-content center;
}

.speech-btn-group {
  display flex;
  flex-direction row;
  align-items center;
  justify-content center;

  .play-record-btn {
    margin 30px;
    background url("../../assets/img/play-record.png")
    width 77px;
    height 77px;
    background-size 100% 100%;
  }

  .gray-play-record-btn {
    filter: grayscale(75%);
    -webkit-filter: grayscale(75%);
    -moz-filter: grayscale(75%);
    -ms-filter: grayscale(75%);
    -o-filter: grayscale(75%);
  }

  .record-group-btn {
    position relative;
    margin 20px;
    width 80px;
    height 80px;
    position relative

    .record-playing {
      position absolute;
      left -2px;
      top -2px;
    }

    .record-btn {
      width 80px;
      height 80px;
      background url("../../assets/img/play-video.png")
      background-size 100% 100%;
      z-index 1001;
    }
  }
}

.speech-word-content {
  font-size 30px;
  text-align center;
  width 80%;
  white-space: pre-line;
}

.speech-word-content1 {
  font-size 30px;
  text-align left;
  width 80%;
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/public/speecchquestion.vue